import { styled } from "../../theme";
export const FieldBorder = styled.div `
  border-bottom: thin solid
    ${({ theme: { color }, focused, invalid }) => invalid
    ? color.deepOrange100
    : focused
        ? color.primary
        : color.borderGray};
`;
